<template>
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M15.9993 29.3337C23.3327 29.3337 29.3327 23.3337 29.3327 16.0003C29.3327 8.66699 23.3327 2.66699 15.9993 2.66699C8.66602 2.66699 2.66602 8.66699 2.66602 16.0003C2.66602 23.3337 8.66602 29.3337 15.9993 29.3337Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.2266 19.7732L19.7732 12.2266"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M19.7732 19.7732L12.2266 12.2266"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss"></style>
